import { DatePickerTheme, multiVariantStyles } from '../DatePickerStyles.css';
import { baseTheme } from './DatePickerBaseTheme.css';

/*******************
 * Component Theme
 *******************/

const DatePickerStableTheme: DatePickerTheme = {
  baseTheme,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { DatePickerStableTheme };
